import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { asArray, filterDuplicates, filterInstances, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { ComponentSync, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Action, ModuleFE_OrderGroup, ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../../../../../../_entity.js';
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
export class Section_AllPathwayOrders extends ComponentSync {
    // ######################## Life Cycle ########################
    __onPathwayStateUpdated(...params) {
        const changedStates = asArray(params[1]);
        if (changedStates.some(state => state.pathwayIds?.includes(this.props.pathwayId)))
            this.reDeriveState();
    }
    __onPathwayTransitionUpdated(...params) {
        const changedTransitions = asArray(params[1]);
        if (changedTransitions.some(transition => transition.pathwayIds?.includes(this.props.pathwayId)))
            this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.relatedEntities = this.getRelatedEntities(nextProps.pathwayId);
        return state;
    }
    // ######################## Logic ########################
    getRelatedEntities(pathwayId) {
        const states = ModuleFE_PathwayState.cache.filter(state => state.pathwayIds.includes(pathwayId));
        const transitions = ModuleFE_PathwayTransition.cache.filter(transition => transition.pathwayIds.includes(pathwayId));
        //Collect ids from states
        const preconditionPointers = states.map(state => state.preconditions.map(precondition => precondition.itemPointer)).flat();
        let orderIds = preconditionPointers.filter(pointer => pointer.dbKey === DBDef_Action.dbKey).map(pointer => pointer.id);
        let groupIds = preconditionPointers.filter(pointer => pointer.dbKey === DBDef_OrderGroup.dbKey).map(pointer => pointer.id);
        //Collect ids from transitions
        const transitionPointers = transitions.map(transition => filterInstances([transition.consultIds, transition.treatmentsIds, transition.testsIds]).flat()).flat();
        const transitionOrderIds = transitionPointers.filter(pointer => pointer.dbKey === DBDef_Action.dbKey);
        const transitionGroupOrderIds = transitionPointers.filter(pointer => pointer.dbKey === DBDef_OrderGroup.dbKey);
        orderIds = filterDuplicates([...orderIds, ...transitionOrderIds.map(pointer => pointer.id)]);
        groupIds = filterDuplicates([...groupIds, ...transitionGroupOrderIds.map(pointer => pointer.id)]);
        return {
            states,
            transitions,
            orders: orderIds.map(id => {
                const order = ModuleFE_Action.cache.unique(id);
                if (!order)
                    throw new MUSTNeverHappenException(`Could not get order for id ${id}`);
                return order;
            }),
            orderGroups: groupIds.map(id => {
                const group = ModuleFE_OrderGroup.cache.unique(id);
                if (!group)
                    throw new MUSTNeverHappenException(`Could not get order group for id ${id}`);
                return group;
            }),
        };
    }
    getSortedItems = () => {
        const items = [];
        const relatedEntities = this.state.relatedEntities;
        relatedEntities.orders.forEach(order => items.push({ itemId: order._id, itemLabel: order.name }));
        relatedEntities.orderGroups.forEach(group => items.push({ itemId: group._id, itemLabel: group.name }));
        return sortArray(items, item => item.itemLabel.toLowerCase());
    };
    // ######################## Render ########################
    render() {
        return _jsx(TS_CollapsableContainerV2, { headerRenderer: this.render_Header(), containerRenderer: this.render_Container(), animated: true });
    }
    render_Header = () => {
        const orderLength = this.state.relatedEntities.orders.length;
        const orderGroupLength = this.state.relatedEntities.orderGroups.length;
        return _jsxs(_Fragment, { children: [orderLength, " Orders, ", orderGroupLength, " Order Groups"] });
    };
    render_Container = () => {
        const items = this.getSortedItems();
        return items.map(item => _jsx("div", { children: item.itemLabel }, item.itemId));
    };
}
//# sourceMappingURL=Section_AllPathwayOrders.js.map